import { ModuleItemType } from '@app/store/shared/models';
import { ModuleValue } from './module.value';

export interface ModuleValueItemDto {
    type: ModuleItemType;
    id: string;
}

export class ModuleValueDto {
    name: string;
    description?: string | null;
    items?: ModuleValueItemDto[];

    constructor(data: ModuleValue) {
        this.name = data.name;

        if (data.description !== undefined) {
            this.description = data.description || null;
        }
        if (data.items !== undefined) {
            this.items = data.items;
        }
    }
}
